import { render, staticRenderFns } from "./OwnerCodeColumn.vue?vue&type=template&id=f49addda&"
import script from "./OwnerCodeColumn.vue?vue&type=script&lang=js&"
export * from "./OwnerCodeColumn.vue?vue&type=script&lang=js&"
import style0 from "./OwnerCodeColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49addda')) {
      api.createRecord('f49addda', component.options)
    } else {
      api.reload('f49addda', component.options)
    }
    module.hot.accept("./OwnerCodeColumn.vue?vue&type=template&id=f49addda&", function () {
      api.rerender('f49addda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/OwnerCodeColumn.vue"
export default component.exports